import auth from "../../middlewares/auth";

export const firewallRoutes = [
    {
        path: '/firewalls',
        component: () => import(/* webpackChunkName: "services" */ '../../views/services/firewalls/FirewallIndex.vue'),
        name: 'firewalls',
        meta: {
            middleware: [
                auth
            ]
        }
    }
]